import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import ReduxFormInput from '../../../shared/components/ReduxFormHandlers/ReduxFormInput';
import * as validate from '../../../helpers/validation.helper';
import LoaderButton from '../../../shared/components/Button/LoaderButton';
import IState from '../../../core/models/IState';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

let ChangePasswordForm: React.FC<any> = (props: any) => {

  const validateConfirmPassword = (message: string) => (value: string, allValues: any) => {
    if (value !== "" && value !== allValues.NewPassword)
      return message;
  }

  return (

    <Modal className="device-pop-up" show={true} centered onHide={props.onModalClosed} dialogClassName="change-password-popup">
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage id='Title_Change_Password' /></Modal.Title>
      </Modal.Header>
      <form onSubmit={props.handleSubmit((values: any) => props.onSubmitForm(values))} noValidate>
        <Modal.Body>
          {!props.isAdmin && <div className="form-group">
            <label className="label-style">
              <FormattedMessage id='ChangePassword_Label_Current_Password' />
            </label>
            <div className="input-group">
              {/* <div className="input-group-prepend">
                <span className="input-group-text justify-content-center">
                  <i className="fa fa-lock" aria-hidden="true"></i>
                </span>
              </div> */}
              <Field
                className="form-control"
                name="CurrentPassword"
                component={ReduxFormInput}
                type="password"
                min={6}
                max={20}
                validate={[
                  validate.validateRequired("Validation_Required_Current_Password"),
                  validate.validatePassword,
                  validate.validateMinLength(6, 'User_Validation_Password_Min_Char'),
                  validate.validateMaxLength(20, 'User_Validation_Password_Max_Char'),
                ]}
              />
            </div>
          </div>
          }
          <div className="form-group">
            <label className="label-style"><FormattedMessage id='Label_New_Password' /> </label>
            <div className="input-group">
              {/* <div className="input-group-prepend">
                <span className="input-group-text justify-content-center">
                  <i className="fa fa-lock" aria-hidden="true"></i>
                </span>
              </div> */}
              <Field
                className="form-control"
                name="NewPassword"
                component={ReduxFormInput}
                type="password"
                min={6}
                max={20}
                validate={[
                  validate.validateRequired("ChangePassword_Validation_New_Required_Password"),
                  validate.validatePassword,
                  validate.validateMinLength(6, 'User_Validation_Password_Min_Char'),
                  validate.validateMaxLength(20, 'User_Validation_Password_Max_Char'),

                ]}
              />
            </div>
          </div>
          <div className="form-group">
            <label className="label-style"><FormattedMessage id='Label_ConfirmPassword' /> </label>
            <div className="input-group">
              {/* <div className="input-group-prepend">
                <span className="input-group-text justify-content-center">
                  <i className="fa fa-lock" aria-hidden="true"></i>
                </span>
              </div> */}
              <Field
                className="form-control"
                name="ConfirmPassword"
                component={ReduxFormInput}
                type="password"
                min={6}
                max={20}
                validate={[validate.validateRequired("Validation_Required_Confirm_Password"),
                validateConfirmPassword("Validation_New_Confirm_Password_Mismatch")
                ]}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={props.onModalClosed} className="btnOkSize"><FormattedMessage id='Button_Cancel' /></Button>
          <LoaderButton type="submit" isLoading={props.loading} text="Button_Save" />
        </Modal.Footer>
      </form>
    </Modal>
  );
};

const selector = formValueSelector('ChangePasswordForm');

const mapStateToProps = (state: IState) => ({
  newPasswordSelector: selector(state, 'NewPassword'),
});

const form = reduxForm<any, any>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true,
  form: 'ChangePasswordForm'
})(ChangePasswordForm)

export default connect(mapStateToProps)(form);
